import { render, staticRenderFns } from "./ItemDisponibilidade.vue?vue&type=template&id=139edff0&"
import script from "./ItemDisponibilidade.vue?vue&type=script&lang=js&"
export * from "./ItemDisponibilidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports